import React from 'react';
import { Body, Box } from '@hover/blueprint';
import { IconProp } from '@hover/icons';
import { motion } from '@hover/blueprint/foundation';
import SwitcherButton from './SwitcherButton';

interface Props {
  activeBackground: 'primary.100' | 'red.100' | 'neutral.0';
  borderColor: 'primary.200' | 'red.100' | 'brandTan.500';
  currentTab: number;
  itemIndex: number;
  isLast: boolean;
  setCurrentTab: React.Dispatch<React.SetStateAction<number>>;
  icon?: IconProp;
  svgIcon?: React.ReactNode;
  title: string;
  titleColor: 'brandNavy.500' | 'red.500';
  body: string;
}

const SwitcherDesktopItem: React.FC<Props> = ({
  activeBackground,
  itemIndex,
  currentTab,
  borderColor,
  isLast,
  setCurrentTab,
  svgIcon,
  icon,
  title,
  body,
  titleColor,
  ...rest
}) => {
  const isCurrent = itemIndex === currentTab;
  const hasBorder = !isCurrent && itemIndex + 1 !== currentTab;

  return (
    <Box
      w="100%"
      flexDir="column"
      py={isCurrent ? 700 : 500}
      bg={isCurrent ? activeBackground : 'none'}
      borderRadius={!isCurrent ? 0 : '8px'}
      transition={`all ${motion.easings[250]}`}
      maxH={isCurrent ? '1000px' : 'auto'}
      borderBottomWidth={hasBorder ? '1px' : 'none'}
      borderBottomColor={borderColor}
      {...rest}
    >
      <SwitcherButton
        currentTab={currentTab}
        itemId={itemIndex}
        setCurrentTab={setCurrentTab}
        title={title}
        titleColor={titleColor}
        isCurrent={isCurrent}
        isLast={isLast}
        svgIcon={svgIcon}
        icon={icon}
      />
      {isCurrent && (
        <Body
          pl={{ base: 500, desktop: 900 }}
          pr={800}
          size={600}
          id={`panel-${itemIndex}`}
          aria-labelledby={`tab-${itemIndex}`}
        >
          {body}
        </Body>
      )}
    </Box>
  );
};

SwitcherDesktopItem.defaultProps = {
  icon: undefined,
  svgIcon: undefined,
};

export default SwitcherDesktopItem;
